export const ADD_COMMAND_START = 'ADD_COMMAND_START';
export const ADD_COMMAND = 'ADD_COMMAND';
export const ADD_COMMAND_SUCCESS = 'ADD_COMMAND_SUCCESS';
export const ADD_COMMAND_FAIL = 'ADD_COMMAND_FAIL';